import { Link } from "gatsby";
import { GatsbyImage } from "gatsby-plugin-image";
import React from "react";

const BlogListing = ({
  data,
  category,
  showImage = true,
  buttonTitle = "Read more",
  title = "",
  description = "",
}) => {
  function getDate(updatedAt) {
    const date = new Date(updatedAt);
    const formattedDate = date.toLocaleString("en-US", {
      weekday: "short",
      month: "short",
      year: "numeric",
    });

    return formattedDate; // Output: "Fri, Mar 2012"
  }

  function truncateText(str, length) {
    return str.length > length ? str.substring(0, length) + "..." : str;
  }

  function extractContentFromHTML(htmlString) {
    if (typeof htmlString === "string") {
      const plainText = htmlString
        ?.replace(/<[^>]+>/g, "")
        .replaceAll("&nbsp;", " ")
        .replaceAll("&rsquo;", "' ")
        .replaceAll("&ndash;", "-")
        .replaceAll("&amp;", "&");

      if (plainText) {
        return truncateText(plainText, 80);
      } else {
        return "";
      }
    }
    return "";
  }

  return (
    <section className="blogListing">
      <div className="blogListing__container">
        <h1 className="text-white font-bold text-3xl md:text-4xl tracking-wide">
          {title}
        </h1>
        {description && <p className="text-white/80">{description}</p>}
        {category && (
          <div className="blogListing__header">
            <div>
              <h2>{category.name}</h2>
              {category?.description && (
                <div
                  className="description"
                  dangerouslySetInnerHTML={{ __html: category?.description }}
                />
              )}
            </div>
            {category?.sponsor && (
              <div className="flex items-center sm:ml-auto">
                <span className="pr-4 text-base uppercase font-medium">
                  Sponsored By:
                </span>
                <a
                  href={category.sponsor.link}
                  target="_blank"
                  rel="noreferrer"
                >
                  <GatsbyImage
                    image={category.sponsor.sponsorLogo.asset.gatsbyImageData}
                    alt={category.sponsor.sponsorName}
                    objectFit="contain"
                    className="w-40 sm:w-48 h-auto object-contain"
                  />
                </a>
              </div>
            )}
          </div>
        )}

        <div className="blogListing__list">
          {data?.map((blog, index) => (
            <div key={index} className="blogcard">
              {showImage && !!blog.images?.length && (
                <Link to={`/${blog.slug}`}>
                  <div className="image__container">
                    <img
                      className="object-cover w-full h-full transition-all duration-300 transform group-hover:scale-125 aspect-[16/9]"
                      src={blog.images[0]}
                      alt={blog.title}
                      loading="lazy"
                    />
                  </div>
                </Link>
              )}
              <div className="blog_title_container">
                <p className="card_tag">{getDate(blog.updated_at)}</p>
                <h2 className="mt-3 tracking-wide">
                  <Link to={`/${blog.slug}`} className="leading-8">
                    {truncateText(blog.title, 55)}
                  </Link>
                </h2>
                <p className="excerpt">{extractContentFromHTML(blog.body)}</p>
                <div className="button">
                  <Link
                    to={`/${blog.slug}`}
                    className="text-inherit no-underline"
                  >
                    {buttonTitle}
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BlogListing;
